export default "__VITE_ASSET__C7l1RVss__"